import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  ViewChild,
  ViewChildren,
  QueryList,
  ElementRef,
  TemplateRef,
} from '@angular/core';

const PAGE_HEIGHT = 1123; // px, A4 at 96dpi

@Component({
  selector: 'app-template1',
  templateUrl: './template1.component.html',
  styleUrls: ['./template1.component.scss'],
})
export class Template1Component implements OnInit {
  @Input() data: any;
  @Input() isThumbnail: boolean = false;

  @ViewChild('measureContainer') measureContainer!: ElementRef;
  @ViewChildren('sectionRefs', { read: ElementRef })
  sectionRefs!: QueryList<ElementRef>;

  allSections: any[] = [];
  pages: any[][] = [];

  constructor() {}

  ngOnInit(): void {}
}
